import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import './meetingInfoModal.css';
import ClockIcon from '../../components/svg/clockIcon';
import CloseIcon from '../../components/svg/closeIcon';
import GoupIconYellow from '../../components/svg/goupIconYellow';
import TextAreaIcon from '../../components/svg/textAreaIcon';
import NotesIcon from '../../components/svg/notesIcon';
import CommonIcon from '../../components/svg/commonIcon.svg';
import { format, max, parse } from 'date-fns';
import { useHistory } from 'react-router';
import PhoneReceiverIcon from '../../components/svg/phoneReceiverIcon';
import InpersonIcon from '../../components/svg/inpersonIcon';
import MeetingTypePhone from '../../components/svg/meetingtypePhone';
import EnglishIcon from '../../components/svg/english.svg';
import QuestionIcon from '../../components/svg/question.svg';
import OpenIcon from '../../components/svg/open.svg';
import CloseIcon2 from '../../components/svg/close.svg';
import DeleteMeetingModal from './DeleteMeetingModal';
import { Button } from '@material-ui/core';
import { deleteMeeting, updateNote } from '../../modals';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '400px',
    padding: '30px 20px 30px 20px',
    borderRadius: '25px',
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: '10',
  },
};
Modal.setAppElement(document.getElementById('root'));

function MeetingInfoModal({
  show,
  showHideModal,
  meetingInfo,
  fromTitle = 'Home',
  fromLink = '/home',
  handleMeetingSummary,
  deleteReasons = []
}) {
  const [showPartnerships, setShowPartnerships] = useState(false);
  const [showMeetingDetails, setShowMeetingDetails] = useState(false);
  const [showDeleteReason, setShowDeleteReason] = useState(false);
  const [selectedReason, setSelectedReason] = useState(deleteReasons[0]?.id);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const history = useHistory();
  const {
    startAndEndTime,
    meetingDate,
    studentDetail,
    meetingLink,
    meetingDetails,
    studentId,
    meetingReasonTypeDesc,
    meetingTypeDesc,
    meetingType,
    counselorPhoneNumber,
    meetingId,
    academicProbation,
    enrolledClass,
    dotFlag,
    meetingLanguage,
    studentPhoneNumber,
    summaryAdded
  } = meetingInfo;
  const [notes, setNotes] = useState(meetingDetails);
  const isPast =
    new Date(`${meetingDate}T${startAndEndTime?.split(' - ')[1] || '00:00:00'}`) < new Date();
  const meetingEndTime = new Date(`${meetingDate}T${startAndEndTime?.split(' - ')[1] || '00:00:00'}`);
  meetingEndTime.setMinutes(meetingEndTime.getMinutes() + 5);

  const isPastPlus5Min = meetingEndTime < new Date();
  const formatTimeRange = (timeRange) => {
    if (!timeRange) return '';
    const [startTime, endTime] = timeRange.split(' - ');
    const formatTime = (time) => {
      const [hours, minutes] = time.split(':');
      const date = new Date();
      date.setHours(parseInt(hours), parseInt(minutes));
      return format(date, 'h:mma').toLowerCase();
    };
    return `${formatTime(startTime)} - ${formatTime(endTime)}`;
  };



  const handleDelete = () => {
    setShowDeleteConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    await deleteMeeting({
      meetingId: meetingInfo.meetingId,
      deleteType: selectedReason || deleteReasons[0]?.id
    })
    setShowDeleteConfirmation(false);
    showHideModal(false);
  };

  useEffect(() => { }, []);
  return (
    <div>
      <Modal
        // ariaHideApp={false}
        isOpen={show}
        // onAfterOpen={}
        onRequestClose={() => {
          showHideModal(false);
        }}
        shouldCloseOnOverlayClick={false}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="popheader SchedulecalanderModal">
          <h2>{studentDetail[0]?.fullName}</h2>
          <span className="popheaderspan">
            <button
              className="transpBtn"
              onClick={() => {
                showHideModal(false);
              }}
            >
              {<CloseIcon />}
            </button>
          </span>
        </div>
        <div class="content" style={{ maxHeight: "70vh", overflowY: 'auto' }}>
          <div className="SchedulecalanderModal">
            <ul className="studentInfo">
              <li>
                <i>{<ClockIcon />}</i>
                <div className="medateandTime">
                  <span className="meetingdate">
                    {format(new Date(...meetingDate.split('-').map((v, i) => i === 1 ? +v - 1 : +v)), 'MMMM dd, yyyy')}
                  </span>
                  <br />
                  <span className="meetingTime">{formatTimeRange(startAndEndTime)}</span>
                </div>
              </li>
              <li>
                <i>
                  <GoupIconYellow />
                </i>
                <div


                >
                  <span className='collapse'>
                    <span className="userName" style={{ cursor: 'pointer' }}
                      onClick={() => {
                        // history.push({
                        //   pathname: '/studentlist',
                        //   studentId: studentDetail[0]?.studentId,
                        // });
                        window.open(
                          `/studentlist?studentId=${studentDetail[0]?.studentId}`,
                          '_blank'
                        );
                        localStorage.setItem('backlink_title_pico', fromTitle);
                        localStorage.setItem('backLink_pico', fromLink);
                      }}>
                      {studentDetail[0]?.fullName}
                    </span>
                    {" "}
                    <span>({studentDetail[0]?.studentId})</span>
                    <img
                      src={showPartnerships ? CloseIcon2 : OpenIcon}
                      alt={showPartnerships ? "Close" : "Open"}
                      style={{ cursor: 'pointer', marginLeft: '5px' }}
                      onClick={() => setShowPartnerships(!showPartnerships)}
                    />
                  </span>
                  {showPartnerships && (
                    <>
                      <span className='meetingTime'>Goal: {studentDetail[0]?.goal || ''}</span>
                      <div className="partnerships">
                        <span>Partnerships:</span>
                        {studentDetail[0]?.partnerNames.map((program, index) => (
                          <span key={index} className="program-tag">{program}</span>
                        ))}
                      </div></>
                  )}
                </div>

              </li>

              {/* <li>
                <i><PhoneReceiverIcon /></i>
                <div className="phone-info">
                  <p>Phone Call</p>
                  <span>Student Phone: {studentDetail[0]?.phoneNumber || '555-555-5555'}</span>
                </div>
              </li> */}

              <li>
                <i>
                  <NotesIcon />
                </i>
                <div>
                  <p>{meetingReasonTypeDesc}</p>
                </div>
              </li>

              <li>
                <i>
                  <img src={CommonIcon} alt="" />
                </i>
                <div className="meetingDetails">
                  <span className='collapse'>
                    <p>{meetingTypeDesc}</p>
                    <img
                      src={showMeetingDetails ? CloseIcon2 : OpenIcon}
                      alt={showMeetingDetails ? "Close" : "Open"}
                      style={{ cursor: 'pointer', marginLeft: '5px' }}
                      onClick={() => setShowMeetingDetails(!showMeetingDetails)}
                    />
                  </span>
                  {showMeetingDetails && (
                    <>
                      {meetingType === 1 && (
                        <div>
                          <button>
                            <a href={meetingLink} target="__balnk">
                              Join on meet
                            </a>
                          </button>
                        </div>
                      )}
                      <div className="meetLink">
                        {meetingType === 1 && (meetingLink || '--')}
                        {meetingType === 2 && (studentPhoneNumber || '--')}
                        {meetingType === 3 && ''}
                      </div>
                    </>
                  )}
                </div>
              </li>
              <li>
                <i><img src={EnglishIcon} alt="English" /></i>
                <div className="language-info">
                  <p>{meetingLanguage}</p>
                </div>
              </li>
              <li>
                <i><img src={QuestionIcon} alt="Question" /></i>
                <div className="enrollment-info">
                  <div className="enrollment-status">
                    <p>Currently enrolled?</p>
                    <span>{enrolledClass ? 'Yes' : 'No'}</span>
                  </div>
                  <div className="academic-status">
                    <p>Academic Probation or dismissal?</p>
                    <span>{academicProbation ? 'Yes' : 'No'}</span>
                  </div>
                </div>
              </li>
              <li className="meeting-info-notes">
                <i>
                  <TextAreaIcon />
                </i>
                {/* <textarea placeholder="Add description"> */}
                {/* <p>{meetingDetails}</p> */}
                <textarea value={notes} onChange={(event) => {
                  setNotes(event.target.value);
                }} onBlur={() => {
                  updateNote({ meetingId: meetingInfo.meetingId, counselorMeetingDetail: notes })
                }} />
              </li>
            </ul>
            {isPastPlus5Min ? <div className="summary-button-container">
              <Button
                variant="contained"
                style={{
                  color: 'white',
                  borderRadius: '20px',
                  textTransform: 'none',
                  padding: '8px 20px',
                  backgroundColor: 'transparent',
                  color: '#1D5EA6',
                  border: '1px solid #1D5EA6',
                  boxShadow: 'none',
                  lineHeight: 'unset',
                }}
                onClick={handleMeetingSummary}
                id={`summary-${meetingId}`}
              >
                {dotFlag ? "Add Meeting Summary" : "View Summary"}
                {dotFlag ? <div className="red-dot"></div> : null}

              </Button>
            </div> : (!isPast && !isPastPlus5Min) ? <div className="delete-meeting-section">
              <div className="reason-selector">
                <button
                  className="delete-btn"
                  onClick={() => setShowDeleteReason(!showDeleteReason)}
                >
                  <span>Delete Meeting</span>
                  <span className={`arrow ${showDeleteReason ? 'open' : ''}`}>▼</span>
                </button>

                {showDeleteReason && (
                  <div className="reason-dropdown">
                    {deleteReasons.map(({ id, value }, index) => (
                      <div
                        key={index}
                        className="reason-option"
                        onClick={() => {
                          setSelectedReason(id);
                          setShowDeleteReason(false);
                          handleDelete();
                        }}
                      >
                        {value}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div> : ""}



          </div>
        </div>
      </Modal>

      <DeleteMeetingModal
        isOpen={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
}

export default MeetingInfoModal;
